// Het woord "Kansrijk" met zijn uitleg (ownerwens 08-10-2026).
//
// Overal waar een gebruiker het label bij regelingen ziet (de strook op
// skill-detail, trend-detail en de Plan-tab, de herkomst in het
// regelingpaneel) staat dit ene component. De uitleg verschijnt bij hover én
// bij toetsenbordfocus, verdwijnt met Escape, en is via aria-describedby ook
// voor een schermlezer de beschrijving van het woord. Zelfde donkere kaartje
// als de pasmaat-uitleg in RegelingenStrook.

import { useId, useState } from "react";

import { KANSRIJK_LABEL, KANSRIJK_UITLEG } from "../lib/kansrijk";
import { color, radius, size, weight } from "../tokens";

export function Kansrijk({
  label = KANSRIJK_LABEL,
  uitleg = KANSRIJK_UITLEG,
}: {
  /** Uit het API-antwoord (`label`) als dat er is; anders de constante. */
  label?: string | null;
  /** Uit het API-antwoord (`labelUitleg`) als dat er is; anders de constante. */
  uitleg?: string | null;
}) {
  const id = useId();
  const [toon, setToon] = useState(false);
  return (
    <span
      style={{ position: "relative", display: "inline" }}
      onMouseEnter={() => setToon(true)}
      onMouseLeave={() => setToon(false)}
    >
      <span
        data-testid="kansrijk"
        tabIndex={0}
        aria-describedby={id}
        onFocus={() => setToon(true)}
        onBlur={() => setToon(false)}
        onKeyDown={(e) => {
          if (e.key === "Escape") setToon(false);
        }}
        style={{
          fontWeight: weight.medium,
          color: "inherit",
          borderBottom: `1px dotted ${color.faint}`,
          cursor: "help",
        }}
      >
        {label || KANSRIJK_LABEL}
      </span>
      <span
        id={id}
        role="tooltip"
        hidden={!toon}
        style={{
          position: "absolute",
          zIndex: 6,
          left: 0,
          top: "100%",
          marginTop: 4,
          width: 300,
          maxWidth: "80vw",
          background: color.ink,
          color: "#ffffff",
          borderRadius: radius.input,
          padding: "8px 10px",
          fontSize: size.label,
          fontWeight: weight.regular,
          lineHeight: 1.5,
          letterSpacing: 0,
          textTransform: "none",
          whiteSpace: "normal",
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
        }}
      >
        {uitleg || KANSRIJK_UITLEG}
      </span>
    </span>
  );
}
